const $ = require('jQuery');

function applicationCard(
  pIcon,
  pTitle,
  pOnClick,
  pIsCreateButton,
  pIsRenaming,
  pOnRename,
  pHasWarnings,
  pApp,
) {
  const lOpenAppButton = $('<button>')
    .addClass('ml_application_landing_page_custom_app_button')
    .addClass('ml_application_landing_page_custom_app_button_with_apps')
    .on('click', () => {
      if (pIsRenaming) return;
      pOnClick && pOnClick();
    });

  if (pIsCreateButton) {
    lOpenAppButton.addClass('ml_application_landing_page_custom_app_button_create');
  }
  else {
    lOpenAppButton.addClass('ml_application_landing_page_custom_app_button_open');
  }

  if (pIsRenaming) {
    const lOnRenameStop = (pEvent) => {
      pEvent.preventDefault();
      pEvent.stopPropagation();
      if (lRenameAppInput.val() !== pTitle) {
        pOnRename(lRenameAppInput.val());
      }
      else {
        pOnRename();
      }
    };
    const lRenameAppInput =  $('<input>')
      .val(pTitle)
      .on('keypress', (pEvent) => {
        if (pEvent.key === 'Enter') {
          lOnRenameStop(pEvent);
        }
      })
      .addClass('ml_application_landing_page_custom_app_button_input')
      .on('blur', lOnRenameStop)
      .on('click', pEvent => pEvent.stopPropagation());
    lOpenAppButton.append(lRenameAppInput);

    setTimeout(() => lRenameAppInput.focus(), 0);
  }
  else {
    const lOpenAppButtonIcon = $('<div>')
      .addClass(pIcon)
      .addClass(pIsCreateButton ? 'ml_application_landing_page_custom_app_button_create_icon' : 'ml_application_landing_page_custom_app_button_open_icon');
    const lOpenAppButtonText = $('<label>')
      .text(pTitle)
      .addClass('ml_application_landing_page_custom_app_button_label')
      .addClass(pIsCreateButton ? 'ml_application_landing_page_custom_app_button_create_text' : 'ml_application_landing_page_custom_app_button_open_text')
      .attr('title', pTitle);

    if (pHasWarnings) {
      const lBadge = $('<span class="ml_validator_badge_ml">').append(
        $('<span class="fas fa-exclamation">').addClass('ml_validator_badge_exclamation_white')
      );
      lBadge.appendTo(lOpenAppButtonIcon);
    }

    lOpenAppButton.append(
      lOpenAppButtonIcon,
      lOpenAppButtonText
    );
  }

  if (!pIsCreateButton && pApp?.isActive()) {
    lOpenAppButton.append(runningAppBackground(pApp));
    lOpenAppButton.addClass('ml_application_landing_page_custom_app_button_with_animated');
  }

  return lOpenAppButton;
}

function runningAppBackground(pApp) {
  const lAnimatedBackground = $('<div>').addClass('ml_animated_background');

  const lUpdateAnimatedBackground = () => {
    lAnimatedBackground.removeClass('paused').removeClass('running');
    if (pApp.isActive()) {
      lAnimatedBackground.show();
      if (pApp.isPaused()) {
        lAnimatedBackground.addClass('paused');
      }
      else if (pApp.isRunning()) {
        lAnimatedBackground.addClass('running');
      }
    }
    else {
      lAnimatedBackground.hide();
    }
  };

  const lAppListener = {
    onStateChanged: function () {
      lUpdateAnimatedBackground();
      if (!pApp.isActive()) {
        pApp.removeListener(lAppListener);
      }
    }
  };

  lUpdateAnimatedBackground();
  pApp.addListener(lAppListener);
  return lAnimatedBackground;
}

module.exports = {
  applicationCard: applicationCard
};
